import { GET_INSTAGRAM_POST_ANALYTICS_SUCCESS, GET_INSTAGRAM_POST_ANALYTICS_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { channels: [], errors: null };

export default function instagramPostsAnalytics(state=INITIAL_STATE, action) {
  switch(action.type) {
    case GET_INSTAGRAM_POST_ANALYTICS_SUCCESS:
      return { ...state, posts: action.payload.data, errors: null }
    case GET_INSTAGRAM_POST_ANALYTICS_FAILURE:
      return { ...state, posts: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
